import Vue from "vue";

const state = {
  messages: [],
};

const getters = {
  unreadMessages: (state, _getters, rootState) => {
    return state.messages.filter((message) => {
      return (
        message.meta.unread && message.serverId === rootState.query.serverId
      );
    }).length;
  },
};

const mutations = {
  saveMessage(state, message) {
    // Only the last 50 messages are stored
    if (state.messages.length > 50) state.messages.shift();

    state.messages.push(message);
  },
  markMessageAsRead(state, payload) {
  if (!payload) return;
  var target = payload.target;
  var targetmode = payload.targetmode;
  if (target == null || targetmode == null) return;

  for (var i = 0; i < state.messages.length; i++) {
    var m = state.messages[i];
    if (m && m.target === target && m.targetmode === targetmode && m.meta) {
      m.meta.unread = false;
    }
  }
},
  removeAllMessages(state) {
    state.messages = [];
  },
};

const actions = {
  async handleReceivedMessages({ dispatch, rootState }, notification) {
  try {
    var q = rootState && rootState.query;
    var me = q && q.queryUser;

    // ✅ daha login/selected server olmadan mesaj gelirse patlamasın
    if (!me || !me.clientId) return;
    if (!notification || !notification.invoker) return;

    if (notification.invoker.clid !== me.clientId) {
      dispatch("saveTextMessage", {
        targetmode: notification.targetmode,
        sender: {
          clid: notification.invoker.clid,
          clientNickname: notification.invoker.clientNickname,
        },
        text: notification.msg,
        meta: { unread: true },
      });
    }
  } catch (err) {
    Vue.prototype.$toast && Vue.prototype.$toast.error(err.message);
  }
},


  async saveTextMessage({ commit, rootState }, { targetmode, sender, text, target, meta }) {
  try {
    var q = rootState && rootState.query;
    var me = q && q.queryUser;
    var serverId = q && q.serverId;

    if (!meta) meta = {};
    meta.timestamp = new Date();

    // ✅ server daha seçilmediyse / queryUser yoksa kayıt atma
    if (!serverId) return;

    if (!target) {
      if (targetmode === 1) {
        target = sender && sender.clid;
      } else if (targetmode === 2) {
        target = me && me.clientChannelId;
      } else if (targetmode === 3) {
        target = serverId;
      }
    }

    if (!target) return;

    commit("saveMessage", {
      sender,
      target,
      targetmode,
      text,
      meta,
      serverId: serverId,
    });
  } catch (err) {
    Vue.prototype.$toast && Vue.prototype.$toast.error(err.message);
  }
},


};

export default {
  state,
  getters,
  mutations,
  actions,
};
